import * as React from "react";
import styled from "styled-components";
import { Fonts } from "../../ui/_assets/fonts";
import { desktop } from "../../ui/_themes/constants";
import { UiBlocker } from "../../v2/components/UiBlocker";

import { ActivityDesktop } from "./Activity";
import { DialogDesktop } from "./Dialogs";
import { DisplayModeSwitcher } from "./DisplayModeSwitcher/Desktop/DisplayModeSwitcher.container";

const StyledContainer = styled.div`
  pointer-events: none;
  padding: 0;
  margin: 0;
  font-family: ${desktop.defaultFont};
  height: 100%;
  font-size: 3vmin;

  @media (max-aspect-ratio: 16/9) {
    font-size: 1.69vw;
  }

  * {
    box-sizing: border-box;
  }
`;

export const Desktop = () => (
  <StyledContainer>
    <Fonts />
    <DisplayModeSwitcher />
    <ActivityDesktop />
    <DialogDesktop />
    <UiBlocker />
  </StyledContainer>
);
